module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAAVCAMAAACaPIWZAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAABaUExURUxpcf///////////////////////////////////////////////////////////////////////////////////////////////////////////////////1YG+bcAAAAddFJOUwD9dQLVx2iqVSrzJDiO/vEdzLymia1Q9AspcRT8yicxRwAAAGdJREFUGNOt0UkOgCAMQNGqIDjPs73/NQVjDQgr4l++RZO2ACqJZgKov7wUZvujSZHZbavmOMdv53RAir56YI4t84gIkeMcWuXujHrovH5HzqjG9ndHEehSVVnONdE9DbfuLCke9pcL/nkg7G7v1IEAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/company-client-landing-page--expanded--review-shape-2@2x.png
// module id = 174
// module chunks = 0